import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { history } from 'kts-platform-frame/routes';
import { tagmodule } from 'src/api';
import { idText } from 'typescript';

class ModulesAction extends ActionBasic<ModulesState> {
    /** 返回登陆页 */
    public go = (router) => {
        history.push(router);
    }  
    /** 获取所有标签以及标签分类 */
    public getAllTagAndCateList = async () => {
        const res = await tagmodule.getAllTagAndCateList(this, null); 
        if (!res.er) { 
            this.modulesState.tagAllCateAndTagData = res.res && res.res.items || [];
            /** 默认全展开 */  
            // this.modulesState.expandedKeys = (res.res && res.res.items || []).map((item)=>item.categoryId+'');
            this.setModulesState();
        }
    }
    /** 新增标签 */
    public addTag = async (rec, callbaksuc, callbakerr) => {
        const res = await tagmodule.addTag(this, {labelName: rec.labelName, categoryId: rec.categoryId}); 
        if (!res.er && res.res.result === 'success') { 
            callbaksuc();
            // this.getTagData();
        } else { 
            callbakerr(res.res && res.res.result);
        }
    }
    /** 新增分类 */
    public addTagCategory = async (rec, callbaksuc, callbakerr) => {
        const res = await tagmodule.addTagCategory(this, {categoryName: rec.categoryName}); 
        if (!res.er && res.res.result === 'success') { 
            callbaksuc(); 
        } else { 
            callbakerr(res.res && res.res.result);
        }
    }
    /** 修改标签 */
    public editTag = async (rec, callbaksuc, callbakerr) => {
        const res = await tagmodule.updateTag(this, {
            labelId: rec.labelId,
            labelName: rec.labelName
        }); 
        if (!res.er && res.res.result === 'success') { 
            callbaksuc();
        } else {
            callbakerr(res.res && res.res.result);
        }
    }
    /** 修改标签分类 */
    public editTagCategory = async (rec, callbaksuc, callbakerr) => {
        const res = await tagmodule.updateTagCategory(this, {
            categoryId: rec.categoryId,
            categoryName: rec.categoryName
        }); 
        if (!res.er && res.res.result === 'success') { 
            callbaksuc();
        } else {
            callbakerr(res.res && res.res.result);
        }
    }
    /** 删除标签 */ 
    public delTag = async (id,callsuc) => {
        const res = await tagmodule.delTag(this, {labelId: id}); 
        if (!res.er) {
            callsuc();
        }
    }
    /** 删除标签分类 */ 
    public delTagCategory = async (id,callsuc) => {
        const res = await tagmodule.delTagCategory(this, {categoryId: id}); 
        if (!res.er) {
            callsuc();
        }
    }
    /** 查询标签关联的公司 */
    public tagLinkCompanys = async (id, callbak) => {
        const res = await tagmodule.tagLinkCompany(this, {labelIds: [id]}); 
        if (!res.er) {   
            callbak(res.res);
        }
    } 
}

export default new ModulesAction();



// WEBPACK FOOTER //
// ./src/display/platform/Network/TagTreeComponent/Modules.Action.ts